import { FC, ReactNode } from 'react';
import { FilterValues } from 'src/types/CataloguePage.types';

export interface FilterParams {
  filter: string;
  sort?: string;
  page?: string;
}

export interface FilterOption {
  value: string;
  label?: string;
  slug: string;
  filter: FilterValues;
  href?: string;
  nofollow?: boolean;
}

export interface FilterItemProps extends Omit<FilterOption, 'label'> {
  label: ReactNode;
  Icon?: FC;
  disabled?: boolean;
}

export interface FilterOptions {
  /** List of makes/models ordered by makes with highest number of cars associated with and models alphabetically */
  makeModel: FilterHierarchyFieldsGroupOption[];
  cashMin: FilterOption[];
  cashMax: FilterOption[];
  financeMin: FilterOption[];
  financeMax: FilterOption[];
  yearMin: FilterOption[];
  yearMax: FilterOption[];
  kmMin: FilterOption[];
  kmMax: FilterOption[];
  transmission: FilterOption[];
  fuelType: FilterOption[];
  highlightedFeatures: FilterOption[];
  bodyType: FilterHierarchyFieldsGroupOption[];
  driveType: FilterOption[];
  seats: FilterOption[];
  doors: FilterOption[];
  colour: FilterOption[];
  co2Emissions: FilterOption[];
  ancapSafetyRating: FilterOption[];
  towCapBrakedMin: FilterOption[];
  towCapBrakedMax: FilterOption[];
}

export interface FilterHierarchyFieldsGroupOption extends FilterItemProps {
  children?: (FilterItemProps & { labelNoCount: ReactNode })[];
  labelNoCount?: ReactNode;
}

type PlpFiltersHierarchyOnClick = (filter: { option: FilterHierarchyFieldsGroupOption; filterTitle: string }) => void;

export type PlpFiltersConditionalProps = PlpFilterItemModalProps | PlpFilterItemSidebarProps;

type PlpFilterItemSidebarProps = {
  type: 'sidebar';
};

type PlpFilterItemModalProps = {
  type: 'modal';
  onSelectHierarchy?: PlpFiltersHierarchyOnClick;
  onSelectFilter: (filter: FilterOption) => void;
};

export type PlpFilterBaseItemProps = {
  index: number;
  showNotificationBadge: boolean;
};

export type PlpFilterItemProps<T> = PlpFilterBaseItemProps & {
  options: T[];
  value: string | number;
} & PlpFiltersConditionalProps;

export type PlpHierarchyFilterItemProps<T> = Prettify<
  Omit<PlpFilterItemProps<T>, 'value'> &
    PlpFiltersConditionalProps & {
      currentFilters: FilterOption[];
    }
>;

export type UnitProcessor = (value: string) => string;

export const enum RangeFilterType {
  price = 'price',
  finance = 'finance',
  year = 'year',
  km = 'km',
  fuel = 'fuel',
  towCap = 'towCap',
}

export type RangeFilterValue = {
  min?: string;
  max?: string;
};
